import { FormControl, FormGroup, Validators } from '@angular/forms';
import { QuickSourceProgressName } from 'src/app/interfaces/quick-source-progress-name';

export class QuickSourceProgressForm extends FormGroup<{
  id: FormControl<number | undefined>;
  ProposalRequestId: FormControl<number | undefined>;
  name: FormControl<QuickSourceProgressName | undefined>;
  status: FormControl<'Started' | 'Complete' | undefined | null>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      ProposalRequestId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      name: new FormControl<QuickSourceProgressName | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      status: new FormControl<'Started' | 'Complete' | undefined | null>(null, {
        validators: [Validators.required]
      })
    });
  }
}
